/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as IndexRouteImport } from './routes/index'
import { Route as AboutRouteImport } from './routes/about'
import { Route as AdminRouteImport } from './routes/admin'
import { Route as ContactRouteImport } from './routes/contact'
import { Route as DemoRouteImport } from './routes/demo'
import { Route as DonateRouteImport } from './routes/donate'
import { Route as DonorRouteImport } from './routes/donor'
import { Route as EmergencyRouteImport } from './routes/emergency'
import { Route as EventsRouteImport } from './routes/events'
import { Route as FaqRouteImport } from './routes/faq'
import { Route as GalleryRouteImport } from './routes/gallery'
import { Route as InstitutionRouteImport } from './routes/institution'
import { Route as LeadershipRouteImport } from './routes/leadership'
import { Route as LoginRouteImport } from './routes/login'
import { Route as MediaRouteImport } from './routes/media'
import { Route as PartnerApplyRouteImport } from './routes/partner-apply'
import { Route as RegisterInstitutionRouteImport } from './routes/register-institution'
import { Route as VolunteerRouteImport } from './routes/volunteer'
import { Route as AdminIndexRouteImport } from './routes/admin.index'
import { Route as AdminApplicationsRouteImport } from './routes/admin.applications'
import { Route as AdminCausesRouteImport } from './routes/admin.causes'
import { Route as AdminDonationsRouteImport } from './routes/admin.donations'
import { Route as AdminDonorsRouteImport } from './routes/admin.donors'
import { Route as AdminInstitutionsRouteImport } from './routes/admin.institutions'
import { Route as AdminPartnersRouteImport } from './routes/admin.partners'
import { Route as AdminPayoutsRouteImport } from './routes/admin.payouts'
import { Route as AdminSettingsRouteImport } from './routes/admin.settings'
import { Route as AdminStoriesRouteImport } from './routes/admin.stories'
import { Route as CampaignsIndexRouteImport } from './routes/campaigns.index'
import { Route as CampaignsIdRouteImport } from './routes/campaigns.$id'
import { Route as CausesIndexRouteImport } from './routes/causes.index'
import { Route as CausesIdRouteImport } from './routes/causes.$id'
import { Route as DonateSuccessRouteImport } from './routes/donate.success'
import { Route as DonorIndexRouteImport } from './routes/donor.index'
import { Route as DonorDiscoverRouteImport } from './routes/donor.discover'
import { Route as DonorFavoritesRouteImport } from './routes/donor.favorites'
import { Route as DonorHistoryRouteImport } from './routes/donor.history'
import { Route as DonorImpactRouteImport } from './routes/donor.impact'
import { Route as DonorProfileRouteImport } from './routes/donor.profile'
import { Route as DonorRecurringRouteImport } from './routes/donor.recurring'
import { Route as InitiativesIndexRouteImport } from './routes/initiatives.index'
import { Route as InitiativesSlugRouteImport } from './routes/initiatives.$slug'
import { Route as InitiativesAnimalSevaRouteImport } from './routes/initiatives.animal-seva'
import { Route as InstitutionIndexRouteImport } from './routes/institution.index'
import { Route as InstitutionCampaignsRouteImport } from './routes/institution.campaigns'
import { Route as InstitutionCausesRouteImport } from './routes/institution.causes'
import { Route as InstitutionDonationsRouteImport } from './routes/institution.donations'
import { Route as InstitutionImpactRouteImport } from './routes/institution.impact'
import { Route as InstitutionPayoutsRouteImport } from './routes/institution.payouts'
import { Route as InstitutionProfileRouteImport } from './routes/institution.profile'
import { Route as InstitutionReportsRouteImport } from './routes/institution.reports'
import { Route as InstitutionsIndexRouteImport } from './routes/institutions.index'
import { Route as InstitutionsIdRouteImport } from './routes/institutions.$id'
import { Route as OrganisationsIndexRouteImport } from './routes/organisations.index'
import { Route as OrganisationsIdRouteImport } from './routes/organisations.$id'
import { Route as StoriesIndexRouteImport } from './routes/stories.index'
import { Route as StoriesIdRouteImport } from './routes/stories.$id'

const IndexRoute = IndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => rootRouteImport,
} as any)
const AboutRoute = AboutRouteImport.update({
  id: '/about',
  path: '/about',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminRoute = AdminRouteImport.update({
  id: '/admin',
  path: '/admin',
  getParentRoute: () => rootRouteImport,
} as any)
const ContactRoute = ContactRouteImport.update({
  id: '/contact',
  path: '/contact',
  getParentRoute: () => rootRouteImport,
} as any)
const DemoRoute = DemoRouteImport.update({
  id: '/demo',
  path: '/demo',
  getParentRoute: () => rootRouteImport,
} as any)
const DonateRoute = DonateRouteImport.update({
  id: '/donate',
  path: '/donate',
  getParentRoute: () => rootRouteImport,
} as any)
const DonorRoute = DonorRouteImport.update({
  id: '/donor',
  path: '/donor',
  getParentRoute: () => rootRouteImport,
} as any)
const EmergencyRoute = EmergencyRouteImport.update({
  id: '/emergency',
  path: '/emergency',
  getParentRoute: () => rootRouteImport,
} as any)
const EventsRoute = EventsRouteImport.update({
  id: '/events',
  path: '/events',
  getParentRoute: () => rootRouteImport,
} as any)
const FaqRoute = FaqRouteImport.update({
  id: '/faq',
  path: '/faq',
  getParentRoute: () => rootRouteImport,
} as any)
const GalleryRoute = GalleryRouteImport.update({
  id: '/gallery',
  path: '/gallery',
  getParentRoute: () => rootRouteImport,
} as any)
const InstitutionRoute = InstitutionRouteImport.update({
  id: '/institution',
  path: '/institution',
  getParentRoute: () => rootRouteImport,
} as any)
const LeadershipRoute = LeadershipRouteImport.update({
  id: '/leadership',
  path: '/leadership',
  getParentRoute: () => rootRouteImport,
} as any)
const LoginRoute = LoginRouteImport.update({
  id: '/login',
  path: '/login',
  getParentRoute: () => rootRouteImport,
} as any)
const MediaRoute = MediaRouteImport.update({
  id: '/media',
  path: '/media',
  getParentRoute: () => rootRouteImport,
} as any)
const PartnerApplyRoute = PartnerApplyRouteImport.update({
  id: '/partner-apply',
  path: '/partner-apply',
  getParentRoute: () => rootRouteImport,
} as any)
const RegisterInstitutionRoute = RegisterInstitutionRouteImport.update({
  id: '/register-institution',
  path: '/register-institution',
  getParentRoute: () => rootRouteImport,
} as any)
const VolunteerRoute = VolunteerRouteImport.update({
  id: '/volunteer',
  path: '/volunteer',
  getParentRoute: () => rootRouteImport,
} as any)
const AdminIndexRoute = AdminIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => AdminRoute,
} as any)
const AdminApplicationsRoute = AdminApplicationsRouteImport.update({
  id: '/applications',
  path: '/applications',
  getParentRoute: () => AdminRoute,
} as any)
const AdminCausesRoute = AdminCausesRouteImport.update({
  id: '/causes',
  path: '/causes',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDonationsRoute = AdminDonationsRouteImport.update({
  id: '/donations',
  path: '/donations',
  getParentRoute: () => AdminRoute,
} as any)
const AdminDonorsRoute = AdminDonorsRouteImport.update({
  id: '/donors',
  path: '/donors',
  getParentRoute: () => AdminRoute,
} as any)
const AdminInstitutionsRoute = AdminInstitutionsRouteImport.update({
  id: '/institutions',
  path: '/institutions',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPartnersRoute = AdminPartnersRouteImport.update({
  id: '/partners',
  path: '/partners',
  getParentRoute: () => AdminRoute,
} as any)
const AdminPayoutsRoute = AdminPayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => AdminRoute,
} as any)
const AdminSettingsRoute = AdminSettingsRouteImport.update({
  id: '/settings',
  path: '/settings',
  getParentRoute: () => AdminRoute,
} as any)
const AdminStoriesRoute = AdminStoriesRouteImport.update({
  id: '/stories',
  path: '/stories',
  getParentRoute: () => AdminRoute,
} as any)
const CampaignsIndexRoute = CampaignsIndexRouteImport.update({
  id: '/campaigns/',
  path: '/campaigns/',
  getParentRoute: () => rootRouteImport,
} as any)
const CampaignsIdRoute = CampaignsIdRouteImport.update({
  id: '/campaigns/$id',
  path: '/campaigns/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const CausesIndexRoute = CausesIndexRouteImport.update({
  id: '/causes/',
  path: '/causes/',
  getParentRoute: () => rootRouteImport,
} as any)
const CausesIdRoute = CausesIdRouteImport.update({
  id: '/causes/$id',
  path: '/causes/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const DonateSuccessRoute = DonateSuccessRouteImport.update({
  id: '/success',
  path: '/success',
  getParentRoute: () => DonateRoute,
} as any)
const DonorIndexRoute = DonorIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => DonorRoute,
} as any)
const DonorDiscoverRoute = DonorDiscoverRouteImport.update({
  id: '/discover',
  path: '/discover',
  getParentRoute: () => DonorRoute,
} as any)
const DonorFavoritesRoute = DonorFavoritesRouteImport.update({
  id: '/favorites',
  path: '/favorites',
  getParentRoute: () => DonorRoute,
} as any)
const DonorHistoryRoute = DonorHistoryRouteImport.update({
  id: '/history',
  path: '/history',
  getParentRoute: () => DonorRoute,
} as any)
const DonorImpactRoute = DonorImpactRouteImport.update({
  id: '/impact',
  path: '/impact',
  getParentRoute: () => DonorRoute,
} as any)
const DonorProfileRoute = DonorProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => DonorRoute,
} as any)
const DonorRecurringRoute = DonorRecurringRouteImport.update({
  id: '/recurring',
  path: '/recurring',
  getParentRoute: () => DonorRoute,
} as any)
const InitiativesIndexRoute = InitiativesIndexRouteImport.update({
  id: '/initiatives/',
  path: '/initiatives/',
  getParentRoute: () => rootRouteImport,
} as any)
const InitiativesSlugRoute = InitiativesSlugRouteImport.update({
  id: '/initiatives/$slug',
  path: '/initiatives/$slug',
  getParentRoute: () => rootRouteImport,
} as any)
const InitiativesAnimalSevaRoute = InitiativesAnimalSevaRouteImport.update({
  id: '/initiatives/animal-seva',
  path: '/initiatives/animal-seva',
  getParentRoute: () => rootRouteImport,
} as any)
const InstitutionIndexRoute = InstitutionIndexRouteImport.update({
  id: '/',
  path: '/',
  getParentRoute: () => InstitutionRoute,
} as any)
const InstitutionCampaignsRoute = InstitutionCampaignsRouteImport.update({
  id: '/campaigns',
  path: '/campaigns',
  getParentRoute: () => InstitutionRoute,
} as any)
const InstitutionCausesRoute = InstitutionCausesRouteImport.update({
  id: '/causes',
  path: '/causes',
  getParentRoute: () => InstitutionRoute,
} as any)
const InstitutionDonationsRoute = InstitutionDonationsRouteImport.update({
  id: '/donations',
  path: '/donations',
  getParentRoute: () => InstitutionRoute,
} as any)
const InstitutionImpactRoute = InstitutionImpactRouteImport.update({
  id: '/impact',
  path: '/impact',
  getParentRoute: () => InstitutionRoute,
} as any)
const InstitutionPayoutsRoute = InstitutionPayoutsRouteImport.update({
  id: '/payouts',
  path: '/payouts',
  getParentRoute: () => InstitutionRoute,
} as any)
const InstitutionProfileRoute = InstitutionProfileRouteImport.update({
  id: '/profile',
  path: '/profile',
  getParentRoute: () => InstitutionRoute,
} as any)
const InstitutionReportsRoute = InstitutionReportsRouteImport.update({
  id: '/reports',
  path: '/reports',
  getParentRoute: () => InstitutionRoute,
} as any)
const InstitutionsIndexRoute = InstitutionsIndexRouteImport.update({
  id: '/institutions/',
  path: '/institutions/',
  getParentRoute: () => rootRouteImport,
} as any)
const InstitutionsIdRoute = InstitutionsIdRouteImport.update({
  id: '/institutions/$id',
  path: '/institutions/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisationsIndexRoute = OrganisationsIndexRouteImport.update({
  id: '/organisations/',
  path: '/organisations/',
  getParentRoute: () => rootRouteImport,
} as any)
const OrganisationsIdRoute = OrganisationsIdRouteImport.update({
  id: '/organisations/$id',
  path: '/organisations/$id',
  getParentRoute: () => rootRouteImport,
} as any)
const StoriesIndexRoute = StoriesIndexRouteImport.update({
  id: '/stories/',
  path: '/stories/',
  getParentRoute: () => rootRouteImport,
} as any)
const StoriesIdRoute = StoriesIdRouteImport.update({
  id: '/stories/$id',
  path: '/stories/$id',
  getParentRoute: () => rootRouteImport,
} as any)

export interface FileRoutesByFullPath {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRouteWithChildren
  '/contact': typeof ContactRoute
  '/demo': typeof DemoRoute
  '/donate': typeof DonateRouteWithChildren
  '/donor': typeof DonorRouteWithChildren
  '/emergency': typeof EmergencyRoute
  '/events': typeof EventsRoute
  '/faq': typeof FaqRoute
  '/gallery': typeof GalleryRoute
  '/institution': typeof InstitutionRouteWithChildren
  '/leadership': typeof LeadershipRoute
  '/login': typeof LoginRoute
  '/media': typeof MediaRoute
  '/partner-apply': typeof PartnerApplyRoute
  '/register-institution': typeof RegisterInstitutionRoute
  '/volunteer': typeof VolunteerRoute
  '/admin/applications': typeof AdminApplicationsRoute
  '/admin/causes': typeof AdminCausesRoute
  '/admin/donations': typeof AdminDonationsRoute
  '/admin/donors': typeof AdminDonorsRoute
  '/admin/institutions': typeof AdminInstitutionsRoute
  '/admin/partners': typeof AdminPartnersRoute
  '/admin/payouts': typeof AdminPayoutsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/stories': typeof AdminStoriesRoute
  '/campaigns/$id': typeof CampaignsIdRoute
  '/causes/$id': typeof CausesIdRoute
  '/donate/success': typeof DonateSuccessRoute
  '/donor/discover': typeof DonorDiscoverRoute
  '/donor/favorites': typeof DonorFavoritesRoute
  '/donor/history': typeof DonorHistoryRoute
  '/donor/impact': typeof DonorImpactRoute
  '/donor/profile': typeof DonorProfileRoute
  '/donor/recurring': typeof DonorRecurringRoute
  '/initiatives/$slug': typeof InitiativesSlugRoute
  '/initiatives/animal-seva': typeof InitiativesAnimalSevaRoute
  '/institution/campaigns': typeof InstitutionCampaignsRoute
  '/institution/causes': typeof InstitutionCausesRoute
  '/institution/donations': typeof InstitutionDonationsRoute
  '/institution/impact': typeof InstitutionImpactRoute
  '/institution/payouts': typeof InstitutionPayoutsRoute
  '/institution/profile': typeof InstitutionProfileRoute
  '/institution/reports': typeof InstitutionReportsRoute
  '/institutions/$id': typeof InstitutionsIdRoute
  '/organisations/$id': typeof OrganisationsIdRoute
  '/stories/$id': typeof StoriesIdRoute
  '/admin/': typeof AdminIndexRoute
  '/campaigns/': typeof CampaignsIndexRoute
  '/causes/': typeof CausesIndexRoute
  '/donor/': typeof DonorIndexRoute
  '/initiatives/': typeof InitiativesIndexRoute
  '/institution/': typeof InstitutionIndexRoute
  '/institutions/': typeof InstitutionsIndexRoute
  '/organisations/': typeof OrganisationsIndexRoute
  '/stories/': typeof StoriesIndexRoute
}
export interface FileRoutesByTo {
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/contact': typeof ContactRoute
  '/demo': typeof DemoRoute
  '/donate': typeof DonateRouteWithChildren
  '/emergency': typeof EmergencyRoute
  '/events': typeof EventsRoute
  '/faq': typeof FaqRoute
  '/gallery': typeof GalleryRoute
  '/leadership': typeof LeadershipRoute
  '/login': typeof LoginRoute
  '/media': typeof MediaRoute
  '/partner-apply': typeof PartnerApplyRoute
  '/register-institution': typeof RegisterInstitutionRoute
  '/volunteer': typeof VolunteerRoute
  '/admin/applications': typeof AdminApplicationsRoute
  '/admin/causes': typeof AdminCausesRoute
  '/admin/donations': typeof AdminDonationsRoute
  '/admin/donors': typeof AdminDonorsRoute
  '/admin/institutions': typeof AdminInstitutionsRoute
  '/admin/partners': typeof AdminPartnersRoute
  '/admin/payouts': typeof AdminPayoutsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/stories': typeof AdminStoriesRoute
  '/campaigns/$id': typeof CampaignsIdRoute
  '/causes/$id': typeof CausesIdRoute
  '/donate/success': typeof DonateSuccessRoute
  '/donor/discover': typeof DonorDiscoverRoute
  '/donor/favorites': typeof DonorFavoritesRoute
  '/donor/history': typeof DonorHistoryRoute
  '/donor/impact': typeof DonorImpactRoute
  '/donor/profile': typeof DonorProfileRoute
  '/donor/recurring': typeof DonorRecurringRoute
  '/initiatives/$slug': typeof InitiativesSlugRoute
  '/initiatives/animal-seva': typeof InitiativesAnimalSevaRoute
  '/institution/campaigns': typeof InstitutionCampaignsRoute
  '/institution/causes': typeof InstitutionCausesRoute
  '/institution/donations': typeof InstitutionDonationsRoute
  '/institution/impact': typeof InstitutionImpactRoute
  '/institution/payouts': typeof InstitutionPayoutsRoute
  '/institution/profile': typeof InstitutionProfileRoute
  '/institution/reports': typeof InstitutionReportsRoute
  '/institutions/$id': typeof InstitutionsIdRoute
  '/organisations/$id': typeof OrganisationsIdRoute
  '/stories/$id': typeof StoriesIdRoute
  '/admin': typeof AdminIndexRoute
  '/campaigns': typeof CampaignsIndexRoute
  '/causes': typeof CausesIndexRoute
  '/donor': typeof DonorIndexRoute
  '/initiatives': typeof InitiativesIndexRoute
  '/institution': typeof InstitutionIndexRoute
  '/institutions': typeof InstitutionsIndexRoute
  '/organisations': typeof OrganisationsIndexRoute
  '/stories': typeof StoriesIndexRoute
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport
  '/': typeof IndexRoute
  '/about': typeof AboutRoute
  '/admin': typeof AdminRouteWithChildren
  '/contact': typeof ContactRoute
  '/demo': typeof DemoRoute
  '/donate': typeof DonateRouteWithChildren
  '/donor': typeof DonorRouteWithChildren
  '/emergency': typeof EmergencyRoute
  '/events': typeof EventsRoute
  '/faq': typeof FaqRoute
  '/gallery': typeof GalleryRoute
  '/institution': typeof InstitutionRouteWithChildren
  '/leadership': typeof LeadershipRoute
  '/login': typeof LoginRoute
  '/media': typeof MediaRoute
  '/partner-apply': typeof PartnerApplyRoute
  '/register-institution': typeof RegisterInstitutionRoute
  '/volunteer': typeof VolunteerRoute
  '/admin/applications': typeof AdminApplicationsRoute
  '/admin/causes': typeof AdminCausesRoute
  '/admin/donations': typeof AdminDonationsRoute
  '/admin/donors': typeof AdminDonorsRoute
  '/admin/institutions': typeof AdminInstitutionsRoute
  '/admin/partners': typeof AdminPartnersRoute
  '/admin/payouts': typeof AdminPayoutsRoute
  '/admin/settings': typeof AdminSettingsRoute
  '/admin/stories': typeof AdminStoriesRoute
  '/campaigns/$id': typeof CampaignsIdRoute
  '/causes/$id': typeof CausesIdRoute
  '/donate/success': typeof DonateSuccessRoute
  '/donor/discover': typeof DonorDiscoverRoute
  '/donor/favorites': typeof DonorFavoritesRoute
  '/donor/history': typeof DonorHistoryRoute
  '/donor/impact': typeof DonorImpactRoute
  '/donor/profile': typeof DonorProfileRoute
  '/donor/recurring': typeof DonorRecurringRoute
  '/initiatives/$slug': typeof InitiativesSlugRoute
  '/initiatives/animal-seva': typeof InitiativesAnimalSevaRoute
  '/institution/campaigns': typeof InstitutionCampaignsRoute
  '/institution/causes': typeof InstitutionCausesRoute
  '/institution/donations': typeof InstitutionDonationsRoute
  '/institution/impact': typeof InstitutionImpactRoute
  '/institution/payouts': typeof InstitutionPayoutsRoute
  '/institution/profile': typeof InstitutionProfileRoute
  '/institution/reports': typeof InstitutionReportsRoute
  '/institutions/$id': typeof InstitutionsIdRoute
  '/organisations/$id': typeof OrganisationsIdRoute
  '/stories/$id': typeof StoriesIdRoute
  '/admin/': typeof AdminIndexRoute
  '/campaigns/': typeof CampaignsIndexRoute
  '/causes/': typeof CausesIndexRoute
  '/donor/': typeof DonorIndexRoute
  '/initiatives/': typeof InitiativesIndexRoute
  '/institution/': typeof InstitutionIndexRoute
  '/institutions/': typeof InstitutionsIndexRoute
  '/organisations/': typeof OrganisationsIndexRoute
  '/stories/': typeof StoriesIndexRoute
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath
  fullPaths:
    | '/'
    | '/about'
    | '/admin'
    | '/contact'
    | '/demo'
    | '/donate'
    | '/donor'
    | '/emergency'
    | '/events'
    | '/faq'
    | '/gallery'
    | '/institution'
    | '/leadership'
    | '/login'
    | '/media'
    | '/partner-apply'
    | '/register-institution'
    | '/volunteer'
    | '/admin/applications'
    | '/admin/causes'
    | '/admin/donations'
    | '/admin/donors'
    | '/admin/institutions'
    | '/admin/partners'
    | '/admin/payouts'
    | '/admin/settings'
    | '/admin/stories'
    | '/campaigns/$id'
    | '/causes/$id'
    | '/donate/success'
    | '/donor/discover'
    | '/donor/favorites'
    | '/donor/history'
    | '/donor/impact'
    | '/donor/profile'
    | '/donor/recurring'
    | '/initiatives/$slug'
    | '/initiatives/animal-seva'
    | '/institution/campaigns'
    | '/institution/causes'
    | '/institution/donations'
    | '/institution/impact'
    | '/institution/payouts'
    | '/institution/profile'
    | '/institution/reports'
    | '/institutions/$id'
    | '/organisations/$id'
    | '/stories/$id'
    | '/admin/'
    | '/campaigns/'
    | '/causes/'
    | '/donor/'
    | '/initiatives/'
    | '/institution/'
    | '/institutions/'
    | '/organisations/'
    | '/stories/'
  fileRoutesByTo: FileRoutesByTo
  to:
    | '/'
    | '/about'
    | '/contact'
    | '/demo'
    | '/donate'
    | '/emergency'
    | '/events'
    | '/faq'
    | '/gallery'
    | '/leadership'
    | '/login'
    | '/media'
    | '/partner-apply'
    | '/register-institution'
    | '/volunteer'
    | '/admin/applications'
    | '/admin/causes'
    | '/admin/donations'
    | '/admin/donors'
    | '/admin/institutions'
    | '/admin/partners'
    | '/admin/payouts'
    | '/admin/settings'
    | '/admin/stories'
    | '/campaigns/$id'
    | '/causes/$id'
    | '/donate/success'
    | '/donor/discover'
    | '/donor/favorites'
    | '/donor/history'
    | '/donor/impact'
    | '/donor/profile'
    | '/donor/recurring'
    | '/initiatives/$slug'
    | '/initiatives/animal-seva'
    | '/institution/campaigns'
    | '/institution/causes'
    | '/institution/donations'
    | '/institution/impact'
    | '/institution/payouts'
    | '/institution/profile'
    | '/institution/reports'
    | '/institutions/$id'
    | '/organisations/$id'
    | '/stories/$id'
    | '/admin'
    | '/campaigns'
    | '/causes'
    | '/donor'
    | '/initiatives'
    | '/institution'
    | '/institutions'
    | '/organisations'
    | '/stories'
  id:
    | '__root__'
    | '/'
    | '/about'
    | '/admin'
    | '/contact'
    | '/demo'
    | '/donate'
    | '/donor'
    | '/emergency'
    | '/events'
    | '/faq'
    | '/gallery'
    | '/institution'
    | '/leadership'
    | '/login'
    | '/media'
    | '/partner-apply'
    | '/register-institution'
    | '/volunteer'
    | '/admin/applications'
    | '/admin/causes'
    | '/admin/donations'
    | '/admin/donors'
    | '/admin/institutions'
    | '/admin/partners'
    | '/admin/payouts'
    | '/admin/settings'
    | '/admin/stories'
    | '/campaigns/$id'
    | '/causes/$id'
    | '/donate/success'
    | '/donor/discover'
    | '/donor/favorites'
    | '/donor/history'
    | '/donor/impact'
    | '/donor/profile'
    | '/donor/recurring'
    | '/initiatives/$slug'
    | '/initiatives/animal-seva'
    | '/institution/campaigns'
    | '/institution/causes'
    | '/institution/donations'
    | '/institution/impact'
    | '/institution/payouts'
    | '/institution/profile'
    | '/institution/reports'
    | '/institutions/$id'
    | '/organisations/$id'
    | '/stories/$id'
    | '/admin/'
    | '/campaigns/'
    | '/causes/'
    | '/donor/'
    | '/initiatives/'
    | '/institution/'
    | '/institutions/'
    | '/organisations/'
    | '/stories/'
  fileRoutesById: FileRoutesById
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute
  AboutRoute: typeof AboutRoute
  AdminRoute: typeof AdminRouteWithChildren
  ContactRoute: typeof ContactRoute
  DemoRoute: typeof DemoRoute
  DonateRoute: typeof DonateRouteWithChildren
  DonorRoute: typeof DonorRouteWithChildren
  EmergencyRoute: typeof EmergencyRoute
  EventsRoute: typeof EventsRoute
  FaqRoute: typeof FaqRoute
  GalleryRoute: typeof GalleryRoute
  InstitutionRoute: typeof InstitutionRouteWithChildren
  LeadershipRoute: typeof LeadershipRoute
  LoginRoute: typeof LoginRoute
  MediaRoute: typeof MediaRoute
  PartnerApplyRoute: typeof PartnerApplyRoute
  RegisterInstitutionRoute: typeof RegisterInstitutionRoute
  VolunteerRoute: typeof VolunteerRoute
  CampaignsIdRoute: typeof CampaignsIdRoute
  CausesIdRoute: typeof CausesIdRoute
  InitiativesSlugRoute: typeof InitiativesSlugRoute
  InitiativesAnimalSevaRoute: typeof InitiativesAnimalSevaRoute
  InstitutionsIdRoute: typeof InstitutionsIdRoute
  OrganisationsIdRoute: typeof OrganisationsIdRoute
  StoriesIdRoute: typeof StoriesIdRoute
  CampaignsIndexRoute: typeof CampaignsIndexRoute
  CausesIndexRoute: typeof CausesIndexRoute
  InitiativesIndexRoute: typeof InitiativesIndexRoute
  InstitutionsIndexRoute: typeof InstitutionsIndexRoute
  OrganisationsIndexRoute: typeof OrganisationsIndexRoute
  StoriesIndexRoute: typeof StoriesIndexRoute
}

declare module '@tanstack/react-router' {
  interface FileRoutesByPath {
    '/': {
      id: '/'
      path: '/'
      fullPath: '/'
      preLoaderRoute: typeof IndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/about': {
      id: '/about'
      path: '/about'
      fullPath: '/about'
      preLoaderRoute: typeof AboutRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin': {
      id: '/admin'
      path: '/admin'
      fullPath: '/admin'
      preLoaderRoute: typeof AdminRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/contact': {
      id: '/contact'
      path: '/contact'
      fullPath: '/contact'
      preLoaderRoute: typeof ContactRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/demo': {
      id: '/demo'
      path: '/demo'
      fullPath: '/demo'
      preLoaderRoute: typeof DemoRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/donate': {
      id: '/donate'
      path: '/donate'
      fullPath: '/donate'
      preLoaderRoute: typeof DonateRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/donor': {
      id: '/donor'
      path: '/donor'
      fullPath: '/donor'
      preLoaderRoute: typeof DonorRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/emergency': {
      id: '/emergency'
      path: '/emergency'
      fullPath: '/emergency'
      preLoaderRoute: typeof EmergencyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/events': {
      id: '/events'
      path: '/events'
      fullPath: '/events'
      preLoaderRoute: typeof EventsRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/faq': {
      id: '/faq'
      path: '/faq'
      fullPath: '/faq'
      preLoaderRoute: typeof FaqRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/gallery': {
      id: '/gallery'
      path: '/gallery'
      fullPath: '/gallery'
      preLoaderRoute: typeof GalleryRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/institution': {
      id: '/institution'
      path: '/institution'
      fullPath: '/institution'
      preLoaderRoute: typeof InstitutionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/leadership': {
      id: '/leadership'
      path: '/leadership'
      fullPath: '/leadership'
      preLoaderRoute: typeof LeadershipRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/login': {
      id: '/login'
      path: '/login'
      fullPath: '/login'
      preLoaderRoute: typeof LoginRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/media': {
      id: '/media'
      path: '/media'
      fullPath: '/media'
      preLoaderRoute: typeof MediaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/partner-apply': {
      id: '/partner-apply'
      path: '/partner-apply'
      fullPath: '/partner-apply'
      preLoaderRoute: typeof PartnerApplyRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/register-institution': {
      id: '/register-institution'
      path: '/register-institution'
      fullPath: '/register-institution'
      preLoaderRoute: typeof RegisterInstitutionRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/volunteer': {
      id: '/volunteer'
      path: '/volunteer'
      fullPath: '/volunteer'
      preLoaderRoute: typeof VolunteerRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/admin/': {
      id: '/admin/'
      path: '/'
      fullPath: '/admin/'
      preLoaderRoute: typeof AdminIndexRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/applications': {
      id: '/admin/applications'
      path: '/applications'
      fullPath: '/admin/applications'
      preLoaderRoute: typeof AdminApplicationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/causes': {
      id: '/admin/causes'
      path: '/causes'
      fullPath: '/admin/causes'
      preLoaderRoute: typeof AdminCausesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/donations': {
      id: '/admin/donations'
      path: '/donations'
      fullPath: '/admin/donations'
      preLoaderRoute: typeof AdminDonationsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/donors': {
      id: '/admin/donors'
      path: '/donors'
      fullPath: '/admin/donors'
      preLoaderRoute: typeof AdminDonorsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/institutions': {
      id: '/admin/institutions'
      path: '/institutions'
      fullPath: '/admin/institutions'
      preLoaderRoute: typeof AdminInstitutionsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/partners': {
      id: '/admin/partners'
      path: '/partners'
      fullPath: '/admin/partners'
      preLoaderRoute: typeof AdminPartnersRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/payouts': {
      id: '/admin/payouts'
      path: '/payouts'
      fullPath: '/admin/payouts'
      preLoaderRoute: typeof AdminPayoutsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/settings': {
      id: '/admin/settings'
      path: '/settings'
      fullPath: '/admin/settings'
      preLoaderRoute: typeof AdminSettingsRouteImport
      parentRoute: typeof AdminRoute
    }
    '/admin/stories': {
      id: '/admin/stories'
      path: '/stories'
      fullPath: '/admin/stories'
      preLoaderRoute: typeof AdminStoriesRouteImport
      parentRoute: typeof AdminRoute
    }
    '/campaigns/': {
      id: '/campaigns/'
      path: '/campaigns'
      fullPath: '/campaigns/'
      preLoaderRoute: typeof CampaignsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/campaigns/$id': {
      id: '/campaigns/$id'
      path: '/campaigns/$id'
      fullPath: '/campaigns/$id'
      preLoaderRoute: typeof CampaignsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/causes/': {
      id: '/causes/'
      path: '/causes'
      fullPath: '/causes/'
      preLoaderRoute: typeof CausesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/causes/$id': {
      id: '/causes/$id'
      path: '/causes/$id'
      fullPath: '/causes/$id'
      preLoaderRoute: typeof CausesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/donate/success': {
      id: '/donate/success'
      path: '/success'
      fullPath: '/donate/success'
      preLoaderRoute: typeof DonateSuccessRouteImport
      parentRoute: typeof DonateRoute
    }
    '/donor/': {
      id: '/donor/'
      path: '/'
      fullPath: '/donor/'
      preLoaderRoute: typeof DonorIndexRouteImport
      parentRoute: typeof DonorRoute
    }
    '/donor/discover': {
      id: '/donor/discover'
      path: '/discover'
      fullPath: '/donor/discover'
      preLoaderRoute: typeof DonorDiscoverRouteImport
      parentRoute: typeof DonorRoute
    }
    '/donor/favorites': {
      id: '/donor/favorites'
      path: '/favorites'
      fullPath: '/donor/favorites'
      preLoaderRoute: typeof DonorFavoritesRouteImport
      parentRoute: typeof DonorRoute
    }
    '/donor/history': {
      id: '/donor/history'
      path: '/history'
      fullPath: '/donor/history'
      preLoaderRoute: typeof DonorHistoryRouteImport
      parentRoute: typeof DonorRoute
    }
    '/donor/impact': {
      id: '/donor/impact'
      path: '/impact'
      fullPath: '/donor/impact'
      preLoaderRoute: typeof DonorImpactRouteImport
      parentRoute: typeof DonorRoute
    }
    '/donor/profile': {
      id: '/donor/profile'
      path: '/profile'
      fullPath: '/donor/profile'
      preLoaderRoute: typeof DonorProfileRouteImport
      parentRoute: typeof DonorRoute
    }
    '/donor/recurring': {
      id: '/donor/recurring'
      path: '/recurring'
      fullPath: '/donor/recurring'
      preLoaderRoute: typeof DonorRecurringRouteImport
      parentRoute: typeof DonorRoute
    }
    '/initiatives/': {
      id: '/initiatives/'
      path: '/initiatives'
      fullPath: '/initiatives/'
      preLoaderRoute: typeof InitiativesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/initiatives/$slug': {
      id: '/initiatives/$slug'
      path: '/initiatives/$slug'
      fullPath: '/initiatives/$slug'
      preLoaderRoute: typeof InitiativesSlugRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/initiatives/animal-seva': {
      id: '/initiatives/animal-seva'
      path: '/initiatives/animal-seva'
      fullPath: '/initiatives/animal-seva'
      preLoaderRoute: typeof InitiativesAnimalSevaRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/institution/': {
      id: '/institution/'
      path: '/'
      fullPath: '/institution/'
      preLoaderRoute: typeof InstitutionIndexRouteImport
      parentRoute: typeof InstitutionRoute
    }
    '/institution/campaigns': {
      id: '/institution/campaigns'
      path: '/campaigns'
      fullPath: '/institution/campaigns'
      preLoaderRoute: typeof InstitutionCampaignsRouteImport
      parentRoute: typeof InstitutionRoute
    }
    '/institution/causes': {
      id: '/institution/causes'
      path: '/causes'
      fullPath: '/institution/causes'
      preLoaderRoute: typeof InstitutionCausesRouteImport
      parentRoute: typeof InstitutionRoute
    }
    '/institution/donations': {
      id: '/institution/donations'
      path: '/donations'
      fullPath: '/institution/donations'
      preLoaderRoute: typeof InstitutionDonationsRouteImport
      parentRoute: typeof InstitutionRoute
    }
    '/institution/impact': {
      id: '/institution/impact'
      path: '/impact'
      fullPath: '/institution/impact'
      preLoaderRoute: typeof InstitutionImpactRouteImport
      parentRoute: typeof InstitutionRoute
    }
    '/institution/payouts': {
      id: '/institution/payouts'
      path: '/payouts'
      fullPath: '/institution/payouts'
      preLoaderRoute: typeof InstitutionPayoutsRouteImport
      parentRoute: typeof InstitutionRoute
    }
    '/institution/profile': {
      id: '/institution/profile'
      path: '/profile'
      fullPath: '/institution/profile'
      preLoaderRoute: typeof InstitutionProfileRouteImport
      parentRoute: typeof InstitutionRoute
    }
    '/institution/reports': {
      id: '/institution/reports'
      path: '/reports'
      fullPath: '/institution/reports'
      preLoaderRoute: typeof InstitutionReportsRouteImport
      parentRoute: typeof InstitutionRoute
    }
    '/institutions/': {
      id: '/institutions/'
      path: '/institutions'
      fullPath: '/institutions/'
      preLoaderRoute: typeof InstitutionsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/institutions/$id': {
      id: '/institutions/$id'
      path: '/institutions/$id'
      fullPath: '/institutions/$id'
      preLoaderRoute: typeof InstitutionsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisations/': {
      id: '/organisations/'
      path: '/organisations'
      fullPath: '/organisations/'
      preLoaderRoute: typeof OrganisationsIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/organisations/$id': {
      id: '/organisations/$id'
      path: '/organisations/$id'
      fullPath: '/organisations/$id'
      preLoaderRoute: typeof OrganisationsIdRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stories/': {
      id: '/stories/'
      path: '/stories'
      fullPath: '/stories/'
      preLoaderRoute: typeof StoriesIndexRouteImport
      parentRoute: typeof rootRouteImport
    }
    '/stories/$id': {
      id: '/stories/$id'
      path: '/stories/$id'
      fullPath: '/stories/$id'
      preLoaderRoute: typeof StoriesIdRouteImport
      parentRoute: typeof rootRouteImport
    }
  }
}

interface AdminRouteChildren {
  AdminApplicationsRoute: typeof AdminApplicationsRoute
  AdminCausesRoute: typeof AdminCausesRoute
  AdminDonationsRoute: typeof AdminDonationsRoute
  AdminDonorsRoute: typeof AdminDonorsRoute
  AdminInstitutionsRoute: typeof AdminInstitutionsRoute
  AdminPartnersRoute: typeof AdminPartnersRoute
  AdminPayoutsRoute: typeof AdminPayoutsRoute
  AdminSettingsRoute: typeof AdminSettingsRoute
  AdminStoriesRoute: typeof AdminStoriesRoute
  AdminIndexRoute: typeof AdminIndexRoute
}

const AdminRouteChildren: AdminRouteChildren = {
  AdminApplicationsRoute: AdminApplicationsRoute,
  AdminCausesRoute: AdminCausesRoute,
  AdminDonationsRoute: AdminDonationsRoute,
  AdminDonorsRoute: AdminDonorsRoute,
  AdminInstitutionsRoute: AdminInstitutionsRoute,
  AdminPartnersRoute: AdminPartnersRoute,
  AdminPayoutsRoute: AdminPayoutsRoute,
  AdminSettingsRoute: AdminSettingsRoute,
  AdminStoriesRoute: AdminStoriesRoute,
  AdminIndexRoute: AdminIndexRoute,
}

const AdminRouteWithChildren = AdminRoute._addFileChildren(AdminRouteChildren)

interface DonateRouteChildren {
  DonateSuccessRoute: typeof DonateSuccessRoute
}

const DonateRouteChildren: DonateRouteChildren = {
  DonateSuccessRoute: DonateSuccessRoute,
}

const DonateRouteWithChildren =
  DonateRoute._addFileChildren(DonateRouteChildren)

interface DonorRouteChildren {
  DonorDiscoverRoute: typeof DonorDiscoverRoute
  DonorFavoritesRoute: typeof DonorFavoritesRoute
  DonorHistoryRoute: typeof DonorHistoryRoute
  DonorImpactRoute: typeof DonorImpactRoute
  DonorProfileRoute: typeof DonorProfileRoute
  DonorRecurringRoute: typeof DonorRecurringRoute
  DonorIndexRoute: typeof DonorIndexRoute
}

const DonorRouteChildren: DonorRouteChildren = {
  DonorDiscoverRoute: DonorDiscoverRoute,
  DonorFavoritesRoute: DonorFavoritesRoute,
  DonorHistoryRoute: DonorHistoryRoute,
  DonorImpactRoute: DonorImpactRoute,
  DonorProfileRoute: DonorProfileRoute,
  DonorRecurringRoute: DonorRecurringRoute,
  DonorIndexRoute: DonorIndexRoute,
}

const DonorRouteWithChildren = DonorRoute._addFileChildren(DonorRouteChildren)

interface InstitutionRouteChildren {
  InstitutionCampaignsRoute: typeof InstitutionCampaignsRoute
  InstitutionCausesRoute: typeof InstitutionCausesRoute
  InstitutionDonationsRoute: typeof InstitutionDonationsRoute
  InstitutionImpactRoute: typeof InstitutionImpactRoute
  InstitutionPayoutsRoute: typeof InstitutionPayoutsRoute
  InstitutionProfileRoute: typeof InstitutionProfileRoute
  InstitutionReportsRoute: typeof InstitutionReportsRoute
  InstitutionIndexRoute: typeof InstitutionIndexRoute
}

const InstitutionRouteChildren: InstitutionRouteChildren = {
  InstitutionCampaignsRoute: InstitutionCampaignsRoute,
  InstitutionCausesRoute: InstitutionCausesRoute,
  InstitutionDonationsRoute: InstitutionDonationsRoute,
  InstitutionImpactRoute: InstitutionImpactRoute,
  InstitutionPayoutsRoute: InstitutionPayoutsRoute,
  InstitutionProfileRoute: InstitutionProfileRoute,
  InstitutionReportsRoute: InstitutionReportsRoute,
  InstitutionIndexRoute: InstitutionIndexRoute,
}

const InstitutionRouteWithChildren = InstitutionRoute._addFileChildren(
  InstitutionRouteChildren,
)

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AboutRoute: AboutRoute,
  AdminRoute: AdminRouteWithChildren,
  ContactRoute: ContactRoute,
  DemoRoute: DemoRoute,
  DonateRoute: DonateRouteWithChildren,
  DonorRoute: DonorRouteWithChildren,
  EmergencyRoute: EmergencyRoute,
  EventsRoute: EventsRoute,
  FaqRoute: FaqRoute,
  GalleryRoute: GalleryRoute,
  InstitutionRoute: InstitutionRouteWithChildren,
  LeadershipRoute: LeadershipRoute,
  LoginRoute: LoginRoute,
  MediaRoute: MediaRoute,
  PartnerApplyRoute: PartnerApplyRoute,
  RegisterInstitutionRoute: RegisterInstitutionRoute,
  VolunteerRoute: VolunteerRoute,
  CampaignsIdRoute: CampaignsIdRoute,
  CausesIdRoute: CausesIdRoute,
  InitiativesSlugRoute: InitiativesSlugRoute,
  InitiativesAnimalSevaRoute: InitiativesAnimalSevaRoute,
  InstitutionsIdRoute: InstitutionsIdRoute,
  OrganisationsIdRoute: OrganisationsIdRoute,
  StoriesIdRoute: StoriesIdRoute,
  CampaignsIndexRoute: CampaignsIndexRoute,
  CausesIndexRoute: CausesIndexRoute,
  InitiativesIndexRoute: InitiativesIndexRoute,
  InstitutionsIndexRoute: InstitutionsIndexRoute,
  OrganisationsIndexRoute: OrganisationsIndexRoute,
  StoriesIndexRoute: StoriesIndexRoute,
}
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>()

import type { getRouter } from './router.tsx'
import type { startInstance } from './start.ts'
declare module '@tanstack/react-start' {
  interface Register {
    ssr: true
    router: Awaited<ReturnType<typeof getRouter>>
    config: Awaited<ReturnType<typeof startInstance.getOptions>>
  }
}
